import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPatch } from 'api-service';
import { toast } from 'lib';
import translation from 'translation';

const { t } = translation;

export const fetchTagCategories = createAsyncThunk(
  'tagReducer/fetchTagCategories',
  async (_, thunkAPI) => {
    try {
      const response = await apiGet(
        '/dynamic_index_analyzer/api/v1/tagCategory',
        {
          with: ['tags'],
          sort: ['created_at,desc'],
          no_paginate: 1,
        }
      );
      return response.data.result.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editTag = createAsyncThunk(
  'tagReducer/editTag',
  async ({ tagId, params }, thunkAPI) => {
    try {
      const response = await apiPatch(
        `/dynamic_index_analyzer/api/v1/tag/${tagId}`,
        params
      );
      toast({
        title: t('common:successOperation'),
        description: t('tag:success.editTag.title'),
      });
      return response.data?.result?.data;
    } catch (error) {
      toast({
        type: 'error',
        title: t('common:errorOperation'),
        description: t('tag:error.editTag.title'),
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchTags = createAsyncThunk(
  'tagReducer/fetchTags',
  async ({ platformForApi }, thunkAPI) => {
    try {
      const response = await apiGet('/search/tags', {
        no_paginate: 1,
        _platformForApi: platformForApi,
      });
      return response.data.result.data;
    } catch (error) {
      thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  tagCategories: {
    data: [],
    loading: false,
    error: null,
  },
  tags: {
    data: [],
    loading: false,
    error: null,
  },
};

export const tagSlice = createSlice({
  name: 'tagSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTagCategories.fulfilled, (state, action) => {
        state.tagCategories.data = action.payload;
        state.tagCategories.loading = false;
        state.tagCategories.error = null;
      })
      .addCase(fetchTagCategories.pending, (state) => {
        state.tagCategories.loading = true;
        state.tagCategories.error = null;
      })
      .addCase(fetchTagCategories.rejected, (state, action) => {
        state.tagCategories.loading = false;
        state.tagCategories.error = action.payload;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.tags.data = action.payload;
        state.tags.loading = false;
        state.tags.error = null;
      })
      .addCase(fetchTags.pending, (state) => {
        state.tags.loading = true;
        state.tags.error = null;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.tags.loading = false;
        state.tags.error = action.payload;
      });
  },
});
